import axios from "axios";

export default async function deleteStaff(access_token, staffId) {
  const resp = await axios.delete(
    `${process.env.REACT_APP_ORGANISER_API}/pos/staff/delete/${staffId}`,
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!resp.data) {
    throw new Error("Some error occured");
  }
  if (resp.data.error) {
    throw new Error(resp.data.error);
  }

  return resp.data;
}
